import { MasterClockType, Status } from 'icreate/common/models/common';
import { ExternalCommunicationWithConfig } from 'icreate/common/models/external-communication';
import { communicationTypes } from 'icreate/common/models/fu-unit';
import { Port } from 'icreate/common/models/port';
import { Slot } from 'icreate/common/models/slot';

export enum SystemSettingTab {
    ops = 'OPS',
    fcu = 'FCU',
    eap = 'EAP',
}

export enum CommonLanguageLabel {
    JP = 'system-settings.common.language.japanese.label',
    EN = 'system-settings.common.language.english.label',
}

export const CommonMasterClockLabel = {
    [MasterClockType.MasterPulse]: 'system-settings.common.clock.master-pulse.label',
    [MasterClockType.MasterComm]: 'system-settings.common.clock.master-comm.label',
    [MasterClockType.Internal]: 'system-settings.common.clock.internal.label',
};

export const slotCounterOptions = [2, 3, 5, 8];

export const defaultExternalCommunication: ExternalCommunicationWithConfig = {
    id: '',
    index: 1,
    fcuId: '',
    vesselId: '',
    commType: communicationTypes.serial,
    isExternalCommunication: true,
    Ports: Array.from({ length: 5 }, (_, i) => new Port(i + 1, communicationTypes.serial)),
};

function createPorts(count: number, type: typeof communicationTypes.serial | typeof communicationTypes.lan): Port[] {
    return Array.from({ length: count }, (_, i) => new Port(i + 1, type));
}

export const defaultCEUSerialPorts: Port[] = createPorts(8, communicationTypes.serial);

export const addedPortOnLanSwitch: Port[] = createPorts(4, communicationTypes.lan);

export const slotTerminalType = {
    normal: 'Normal',
    relay: 'Relay',
} as const;

export type SlotTerminalType = (typeof slotTerminalType)[keyof typeof slotTerminalType];

export const terminalBoardPinNumMax = 64;

const defaultSlotTemplate = {
    id: '',
    fcuId: '',
    fuId: null,
    vesselId: '',
    ioType: '',
    enable: false,
    terminal: [],
} as Slot;

export const defaultSlotList: Slot[] = Array.from({ length: 8 }, (_, i) => ({
    ...defaultSlotTemplate,
    no: i + 1,
}));
